import type { UseMultiCustomerMarketDataSnapshotRequest, UseMultiMarketDataSnapshotRequest } from '@talos/kyoko';
import {
  buildPriceGridCustomerMarketDataRequests,
  buildPriceGridMarketDataRequests,
  getPriceGridCustomerMarketDataRequest,
  getPriceGridMarketDataRequest,
  PRICE_GRID_CUSTOMER_MARKET_DATA_COLUMN_TYPE,
  PRICE_GRID_MARKET_DATA_COLUMN_TYPE,
} from '../../columns';
import type { PriceGridMarketDataEnrichmentSpec } from './types';
import { hasPriceGridColumnType } from './utils';

export const PRICE_GRID_MARKET_DATA_ENRICHMENT_SPEC_ID = 'market';
export const PRICE_GRID_CUSTOMER_MARKET_DATA_ENRICHMENT_SPEC_ID = 'customer';

export const PRICE_GRID_MARKET_DATA_ENRICHMENT_SPEC: PriceGridMarketDataEnrichmentSpec<UseMultiMarketDataSnapshotRequest> =
  {
    id: PRICE_GRID_MARKET_DATA_ENRICHMENT_SPEC_ID,
    isColumnRelevant: column => hasPriceGridColumnType({ column, columnTypes: [PRICE_GRID_MARKET_DATA_COLUMN_TYPE] }),
    buildRequests: buildPriceGridMarketDataRequests,
    getLookupKey: ({ column, item }) => getPriceGridMarketDataRequest(column, item)?.key,
  };

export const PRICE_GRID_CUSTOMER_MARKET_DATA_ENRICHMENT_SPEC: PriceGridMarketDataEnrichmentSpec<UseMultiCustomerMarketDataSnapshotRequest> =
  {
    id: PRICE_GRID_CUSTOMER_MARKET_DATA_ENRICHMENT_SPEC_ID,
    isColumnRelevant: column =>
      hasPriceGridColumnType({ column, columnTypes: [PRICE_GRID_CUSTOMER_MARKET_DATA_COLUMN_TYPE] }),
    buildRequests: buildPriceGridCustomerMarketDataRequests,
    getLookupKey: ({ column, item }) => getPriceGridCustomerMarketDataRequest(column, item)?.key,
  };

export const PRICE_GRID_MARKET_DATA_ENRICHMENT_SPECS = [
  PRICE_GRID_MARKET_DATA_ENRICHMENT_SPEC,
  PRICE_GRID_CUSTOMER_MARKET_DATA_ENRICHMENT_SPEC,
];
